export const SET_AUTH_STATUS = "SET_AUTH_STATUS";
export const SET_USER = "SET_USER";